/**
 * Simple registry allowing data widgets to expose their refetch callback
 * so the grid titlebar can show a refresh button.
 *
 * Widgets call `registerRefetch(widgetId, refetchFn)` on mount
 * and `unregisterRefetch(widgetId)` on unmount.
 */

const registry = new Map<string, () => void>();
const listeners = new Set<() => void>();

export function registerRefetch(widgetId: string, refetch: () => void): void {
  registry.set(widgetId, refetch);
  listeners.forEach(fn => fn());
}

export function unregisterRefetch(widgetId: string): void {
  registry.delete(widgetId);
  listeners.forEach(fn => fn());
}

export function getRefetch(widgetId: string): (() => void) | undefined {
  return registry.get(widgetId);
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
